


























import { Component, Vue, Prop } from 'vue-property-decorator';
import { QSelect, QBadge, QItem } from 'quasar';
import { IProject } from '@/ts/interfaces/ProjectInterface';

@Component({
    components: { QSelect, QBadge, QItem },
})

export default class ProjectSelector extends Vue {
    @Prop({
        default: null,
    }) public value: IProject;

    @Prop({
        default : (): IProject[] => {
            return [];
        },
        required: true,
    }) public projectList: IProject[];

    get selectedProject() {
        return this.value;
    }

    set selectedProject(value) {
        this.$emit('input', value);
    }

    get getProjectList(): IProject[] {
        return this.projectList;
    }
}

